import React, { Component } from "react";
import {Link} from "react-router-dom";
import DatePicker from 'react-date-picker';
import Select from "react-select";

import './NewScheduleRoute.scss';
import MyContext from '../MyContext.jsx';
import {epochToDate} from '../../assets/js/handy.mjs';

class NewScheduleRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routes : [],
      route : {},
      scheduled_date : new Date(),
      schedules : []
    }
  }

  componentDidMount(){   
    $(".react-date-picker__inputGroup input").attr("readonly","true");
    this.getScheduleRoutes();    
  }



  getScheduleRoutes(){
    const url = `${process.env.REACT_APP_SSS}/api/getExeScheduleRoutes`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          routes : return_data.routes,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      // obj_this.props.history.replace("/");
    });
  }

  routeChange(option){
    // console.log(option);
    this.setState({
      route : option
    }); 
  }

  onDateChange(value){
    // console.log(value);
    this.setState({scheduled_date : value});
  }

  handleAddSchedule = () => {
    // console.log(this.state.rows);
    if(!this.state.scheduled_date){
      alert('Date required');
      return;
    }
    const schedule = {
      route : this.state.route,
      scheduled_date : this.state.scheduled_date.toLocaleDateString('en-CA'),
    };

    const schedules = this.state.schedules;

    for(var i=0;i<schedules.length;i++){
      if(schedules[i].route.label === schedule.route.label && schedules[i].scheduled_date === schedule.scheduled_date){
        alert(schedule.route.label+" is already scheduled with this date");
        return;
      }
    }
    this.setState({
      schedules: [...this.state.schedules, schedule],
      route : {},
      scheduled_date : new Date()
    });    
  };

  handleRemoveSchedule = (idx) => () => {
    // console.log(idx);
    const schedules = [...this.state.schedules];
    schedules.splice(idx, 1);
    this.setState({ 
      schedules 
    });

  }

  formSubmit(e){
    e.preventDefault();
    // console.log(this.state);
    // return;
    if(!this.state.schedules.length){
      return;
    }
    const schedules = this.state.schedules;
    const url = `${process.env.REACT_APP_SSS}/api/saveExeScheduleRouteRequest`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid,
        schedules : schedules
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({ 
          schedules : []
        });
        alert("Route(s) Scheduled");
        // obj_this.props.history.replace('/schedules');
        obj_this.context.loading(0);
      }else if(return_data.status == "already"){
        obj_this.setState({ 
          schedules : []
        });
        alert("One or more Route(s) already Scheduled");
        obj_this.context.loading(0);
      }
      else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
     }).fail(function(){
      alert("Network error");
      obj_this.context.loading(0);
      obj_this.props.history.replace("/");
    });
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="new_schedule_container">
          <div className="page_header">
            
            <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Schedule Route</div>
          </div> 
          <form className="schedule_form"
            onSubmit={e => this.formSubmit(e)}
          >
            <div className="customer_details_container blocks">
            
              <div className="input_label">Routes</div>
              <Select 
                options={this.state.routes}  
                value ={this.state.route}
                className="route" 
                ref={r => {
                  this.refs = r;
                }}
                onChange={e => this.routeChange(e)}
                required
              />
              <div className="input_label">Date</div>
              <DatePicker
                className="input custom_input"
                onChange={(value) => this.onDateChange(value)}
                value={this.state.scheduled_date}
                minDate = {new Date()}
                required
                format="dd-MM-y"
              />
              <div className="add_button_container">
                <button className="add_schedule_button"
                  type="button"
                  style={{visibility:this.state.route.label?"visible":"hidden"}}
                  onClick={this.handleAddSchedule}
                > 
                  <i className="fa fa-plus"></i> Add
                </button>
              </div>
            </div>
            <div className="schedules_table_container blocks"
              style={{visibility:this.state.schedules.length?"visible":"hidden"}}
            >
              <table>
                <thead>
                  <tr>
                    <th>Sl No.</th>
                    <th align="left">Route</th>
                    <th align="left">Date</th>
                    <th>Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.schedules.map((item,idx) => (
                    <tr key={idx}>
                      <td align="center">{idx+1}</td>
                      <td>{item.route.label}</td>
                      {/* <td>{item.scheduled_date}</td> */}
                      <td>{new Date(item.scheduled_date).toLocaleDateString('en-GB')}</td>
                      <td align="center">
                        <i className="remove_schedule_button fas fa-times"
                          onClick={this.handleRemoveSchedule(idx)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <button type="submit" 
            className="submit_button"
            style={{visibility:this.state.schedules.length?"visible":"hidden"}}
            >
              <i className="far fa-save"></i> Request
            </button>
          </form>           
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default NewScheduleRoute;
NewScheduleRoute.contextType = MyContext;
